export default function fromEntries(iterable) {
  const isIterable = typeof iterable[Symbol.iterator] === 'function';

  const isIterableOfArray = isIterable
    && [...iterable].reduce((acc, curr) => acc && Array.isArray(curr), true);

  return isIterableOfArray
    ? [...iterable].reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {})
    : undefined;
}
